import React, { createContext, useContext, useState } from "react";

interface LanguageContextProps {
  country: string;
  language: string;
  setCountry: (c: string) => void;
  setLanguage: (l: string) => void;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [country, setCountry] = useState("");
  const [language, setLanguage] = useState("");

  return (
    <LanguageContext.Provider value={{ country, language, setCountry, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used inside LanguageProvider");
  return context;
};
